import React from "react";
import { FaUser } from "react-icons/fa";
import collectibles from "assets/images/collectiblesimage2.png";
import user from "assets/images/user.svg";
import grid from "assets/images/grid.svg";
import codesandbox from "assets/images/codesandbox.svg";
import stories from "assets/images/stories.png";

const TradingCollectible = () => {
  return (
    <div className="trading-collectible mx-3 position-relative">
      <div className="container">

        <div className="row">
          <div className="text-center">
            <p className="about-title">GangstaBet Features </p>
            <p className="about-subtitle story--subtitle">
              GangstaBets have three changeable properties. The owner of the NFT
              can change the name, increase the skills and/or add unique stories of the NFT, if you have
              enough $GBET tokens. Their ranks will also level up as you increase their skills.
            </p>
          </div>
          <div className="col-md-6 trading-collectible-col text-center">
            <img src={collectibles} alt="background" className="trading" style={{ "width": "90%" }} />
          </div>


          <div className="col-md-4 trading-collectible-col">
            <div>
              {/* <p className="pre-title">What is gangstabet</p> */}
              {/* <p className="about-title">Changeable Properties: </p>
              <p className="about-subtitle">
                GangstaBets have two changeable properties. The owner of the NFT
                can change the name and/or increase the skills, if you have
                enough $GBET tokens. Their ranks will also level up as you
                increase their skills.
              </p> */}
            </div>
            <div>
              <ul className="about-gangesta">
                <li className="d-flex">
                  <div className="icons" style={{ "width": "95px" }}>
                    <img src={user} alt="User" className="icon" />
                  </div>
                  <div>
                    <p className="feature">Naming</p>
                    <p className="feature-description">
                      Every GangstaBet will have a unique name, so please choose
                      the name wisely.
                    </p>
                  </div>
                </li>
                <li className="d-flex">
                  <div className="icons" style={{ "width": "144px" }}>
                    <img src={grid} alt="Grid" className="icon" />
                  </div>
                  <div>
                    <p className="feature">Teams & Classes</p>
                    <p className="feature-description">
                      There are 5 classes for gangsters and 4 classes for
                      detectives. The class will determine what type of skills
                      they will have.
                    </p>
                  </div>
                </li>
                <li className="d-flex">
                  <div className="icons" style={{ "width": "154px" }}>
                    <img src={codesandbox} alt="Codesandbox" className="icon" />
                  </div>
                  <div>
                    <p className="feature">Skills & Ranks</p>
                    <p className="feature-description">
                      As you increase your GangstaBet’s skills, you will move up
                      the 10 different ranks within the world of gangsters and
                      detectives.
                    </p>
                  </div>
                </li>
                <li className="d-flex">
                  <div className="icons" style={{ "width": "115px" }}>
                    <img src={stories} alt="Codesandbox" className="icon" />
                  </div>
                  <div>
                    <p className="feature">Stories</p>
                    <p className="feature-description">
                      You can write a new story and/or add-on to the stories of the GangstaBet NFTs that you own.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingCollectible;
